import { IAuthToken } from '../models/auth';
import { ITextMessage } from '../models/text_message';
import { ApiSuccessResponse, IApiService, IPaginatedResponse } from '../services/api_service';

export const textMessage = (siteApi: IApiService, centralApi: IApiService, getToken: () => IAuthToken) => ({
  index: (params = {}): Promise<IPaginatedResponse<ITextMessage>> => {
    return siteApi.get('/text-message', { params });
  },
  excelIndexUrl: (params) => {
    return siteApi.buildUrl('/text-message.xls', {
      ...params,
      token: getToken().accessToken
    });
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/text-message.pdf', {
      ...params,
      token: getToken().accessToken
    });
  },
  asset: {
    delete: (id, data): Promise<ApiSuccessResponse<{ id: number, message: string }>> => {
      return centralApi.delete(`/text-message/${id}/asset`, { params: data });
    }
  }
});
